import React from 'react';
import Reflux from 'reflux';
import UserListItem from './UserListItem';

export default class UserList extends Reflux.Component {
    usersNoResult = () => {
        switch (this.props.type) {
        case 'followers':
            return 'Aún no tiene seguidores';
        case 'following':
            return 'Aún no sigue a nadie';
        case 'search':
            return 'No hay usuarios relacionados a tu busqueda';
        default:
            return 'No se encontraron usuarios';
        }
    }
    render () {
        return (
          <div className='row'>
            {
              this.props.users && this.props.users.length > 0
              ? this.props.users.map((user) => {
                  return <UserListItem key={user._id} user={user} />;
              })
              : <div className='box-notfollow'>
                <img src='/images/icons/notfollow.svg' />
                <div className='txt-follow'>
                  <h4>{this.usersNoResult()}</h4>
                  <p>Explora Top5 para conocer más Tops!</p>
                </div>
              </div>
            }
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/UserList.js